export class AuthenticatorsConfig {
    authenticatorId: string;
    identifier: string;
    type: string;
    name: string;
    loginUrl: string;
    getLogoutUrl: string;
    hasLogout: boolean;
    allowPasswordRecovery: boolean;
}
  